import {
  Host,
  Input,
  OnInit,
  Optional,
  SkipSelf,
  ViewChild,
  Component,
  ElementRef,
  forwardRef,
} from '@angular/core';

import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';

import {BaseControl, BaseControlComponent, Helper} from '../../classes';

@Component({
  selector: 'app-panel-input',
  templateUrl: Helper.getPortalTemplate(),
  styleUrls: [Helper.getPortalStyle()],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PanelInputComponent),
      multi: true,
    },
  ],
})
export class PanelInputComponent extends BaseControlComponent<string | number | null, KeyboardEvent, BaseControl> implements OnInit {
  @ViewChild('input', { static: true }) inputReference: ElementRef | undefined;

  @Input() public disabled: boolean | undefined;
  @Input() public hasHint: boolean | undefined;
  @Input() public outlined: boolean | undefined;

  constructor(
    @Optional()
    @Host()
    @SkipSelf()
    protected controlContainer: ControlContainer,
  ) {
    super(controlContainer);
  }

  ngOnInit(): void {
    this.asFormsControl();
    this.checkInvalid();
  }

  toUpperCase(event: KeyboardEvent): void {
    if (this.asFormsControl().upperCaseValue && /^[a-z]$/.test(event.key) &&  !event.ctrlKey) {
      const { selectionStart, selectionEnd } = event.target as HTMLInputElement;
      const isTextSelected = selectionStart !== selectionEnd;

      if (!isTextSelected) {
        const value = (event.target as HTMLInputElement).value;
        const valueLength = (event.target as HTMLInputElement).value.length;

        if (selectionEnd && selectionEnd < valueLength) {
          if (selectionEnd > 0) {
            (event.target as HTMLInputElement).value = [
              value.substring(0, selectionEnd),
              event.key.toUpperCase(),
              value.substring(selectionEnd),
            ].join('');
          } else {
            (event.target as HTMLInputElement).value = event.key.toUpperCase() + value;
          }

          (event.target as HTMLInputElement).setSelectionRange(selectionEnd + 1, selectionEnd + 1);
        } else {
          (event.target as HTMLInputElement).value = value + event.key.toUpperCase();
        }
      } else {
        (event.target as HTMLInputElement).value = event.key.toUpperCase();
      }

      event.preventDefault();
    }
  }

  changeValue(event: Event): void {
    let value = (event.target as HTMLInputElement)?.value;

    if (event instanceof ClipboardEvent) {
      const clipboardData = event.clipboardData;

      value = clipboardData?.getData('text') ?? '';

      if (this.asFormsControl().upperCaseValue) {
        (event.target as HTMLInputElement).value = value = value.toUpperCase();

        event.preventDefault();
      }
    }

    if (this.onChange) {
      this.onChange(value);
    }

    this.checkInvalid();

    if (this.control) {
      this.control.resetErrors();
    }

    super.writeValue(value);
  }

  writeValue(value: string): void {
    if (this.inputReference) {
      this.inputReference.nativeElement.value = value;
    }

    this.checkInvalid();

    this.control?.resetErrors();

    super.writeValue(value);
  }

  asFormsControl(): BaseControl {
    if (!this.control) {
      this.control = new BaseControl({
        name: '',
        value: '',
        placeholder: '',
        validators: [],
        componentType: 0,
        invalid: false,
        errors: [],
      });
    }

    if ((typeof this.controlPlaceHolder !== 'undefined') && this.control) {
      this.control.placeholder = this.controlPlaceHolder;
    }

    return this.control;
  }
}
